<style>
.van-tabs--line .van-tabs__wrap{height: 88px}
.van-tabs__wrap--scrollable .van-tab{margin:0px 5px}
.van-tabs__content--animated{background: linear-gradient( 153deg, #EBF3FD 0%, #F4F8FC 100%);box-shadow: 0px 0px 4px 1px rgba(10,63,190,0.16);border-radius: 3px;border: 1px solid #FFFFFF;}
</style>
<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="banner-box">
      <div class="banner-con">
        <div class="banner-title">轻骑兵<div style="font-size: 13px;vertical-align: super;line-height: 27px">®</div>融合集成平台</div>
        <div class="banner-desc">高效互通，无缝集成</div>
        <div class="app-button-div">
          <img class="app-button-img" src="../assets/img/zeroCodePhone/app-button-bg.png" @click="handleOpenPractice"/>
        </div>
        <!--更敏捷的企业数字化转型支撑工具-->
        <div class="div-title">融合集成平台</div>
        <div class="div-desc">统一、高效、低门槛的跨系统连接解决方案</div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">打通业务边界</div>
            <div class="base-content-desc">低成本适配新旧架构，实现跨系统业务协同，加速数据流动和汇聚，实现数据价值。</div>
          </div>
          <div>
            <img src="../assets/img/fusionIntegrationPhone/base-img1.png"/>
          </div>
        </div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">服务重组与编排</div>
            <div class="base-content-desc">通过可视化拖拽配置就可编排重组企业已有的服务资产，构建新API服务或集成方案。</div>
          </div>
          <div>
            <img src="../assets/img/fusionIntegrationPhone/base-img2.png"/>
          </div>
        </div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">提升服务质量</div>
            <div class="base-content-desc">提供服务运行深度监控，构建全面的集成监控和预警体系，快速定位问题。</div>
          </div>
          <div>
            <img src="../assets/img/fusionIntegrationPhone/base-img3.png"/>
          </div>
        </div>
        <div class="base-content-div" style="margin-bottom: 50px">
          <div>
            <div class="base-content-title">沉淀服务资产</div>
            <div class="base-content-desc">形成统一标准的API/消息服务，并沉淀到资源市场中，供企业内外部开发人员使用。</div>
          </div>
          <div>
            <img src="../assets/img/fusionIntegrationPhone/base-img4.png"/>
          </div>
        </div>
        <!-- 企业数字化建设的底座-->
        <!--更敏捷的企业数字化转型支撑工具-->
        <div class="digitalize">
          <div class="div-title">融合集成平台</div>
          <div class="div-title" style="margin-top: -15px">助力企业实现信息流动与系统整合</div>
          <div class="div-desc">轻松连接 高效互通 无缝集成</div>
          <div class="digitalize-bg">
            <img src="../assets/img/fusionIntegrationPhone/digitalize.png" />
          </div>
        </div>
        <!-- 融合集成平台 助力企业实现信息流动与系统整合 -->
        <div class="main-method">
          <div class="div-title">主要功能</div>
          <van-tabs
            v-model="mainActive"
            animated
            swipeable
            duration="0.5"
            line-width="90px"
            line-height="2px"
            title-active-color="#186CF5"
            color="#186CF5"
            style="z-index: 5"
          >
            <van-tab name="first">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/fusionIntegrationPhone/tab1.png"></div>
                接口快速开发
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/fusionIntegration/function-box-img1.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>将已有后端服务(API)通过在线可视化配置的方式注册到平台上，实现业务能力和数据的简单、快速、安全开放。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="second">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/fusionIntegrationPhone/tab2.png"></div>
                接口编排开发
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/fusionIntegration/function-box-img2.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>通过图形化编排的方式组合已有API服务开放为新的APl，通过对API的多次组装形成组合应用，实现快速复制创新。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="third">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/fusionIntegrationPhone/tab3.png"></div>
                数据集成
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/fusionIntegration/function-box-img3.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>支持MYSQL、达梦、Oracle、人大金仓等7种关系型数据库。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="fourth">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/fusionIntegrationPhone/tab4.png"></div>
                消息集成
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/fusionIntegration/function-box-img4.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>支持Kafka、RabbitMQ、MQTT等 多种消息队列。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="fifth">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/fusionIntegrationPhone/tab5.png"></div>
                接口运维管理
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/fusionIntegration/function-box-img5.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>记录应用接口发布日志、接口运行日志等，并对接口调用情况做出统计分析，方便企业API运维管理。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="sixth">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/fusionIntegrationPhone/tab6.png"></div>
                资产市场
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/fusionIntegration/function-box-img6.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>企业开放接口/事件的汇聚之地，提供API检索、API文档及权限控制等功能，帮助企业管理开放能力。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="seventh">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/fusionIntegrationPhone/tab7.png"></div>
                接口安全治理
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/fusionIntegration/function-box-img7.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>接口安全治理不仅提供全方位的网络安全防护，确保数据安全无忧，同时稳定保障系统运行，为业务稳健发展筑牢安全防线。</div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
        <!-- 各类业务无缝集成 -->
        <div class="div-title" style="margin-bottom: 25px">各类业务无缝集成</div>
        <div class="core-value">
          <div class="core-layout">
            <div class="core-content">
              <div class="core-item">
                <div>
                  <span class="value-title">企业内部应用互联互通</span>
                  <div class="value-desc">融合集成平台可构建统一的数据管理平台，将各个系统的数据进行整合和统一管理，支持数据分析和挖掘功能，帮助企业更好地利用数据资源，打破数据孤岛，实现数据的共享和流通。</div>
                  <img src="../assets/img/fusionIntegrationPhone/core-item-1.png" style="width: 140px;top: -120px;left: 200px;"/>
                </div>
              </div>
              <div class="core-item">
                <div>
                  <span class="value-title">企业内外部应用高效协同</span>
                  <div class="value-desc">融合集成平台作为企业内部与外部之间进行高效、灵活协作的重要桥梁，可整合各个系统接口，提供统一、安全的输出接口，实现“对外能力开放，对内服务集成”。</div>
                  <img src="../assets/img/fusionIntegrationPhone/core-item-2.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部公司信息 -->
        <CompanyInformation
          @changePracticeMenuShow="handleOpenPractice"
        ></CompanyInformation>
      </div>
      <!-- 右侧菜单 -->
      <RightMenu
        :isMenuShow="isMenuShow"
        @rightMenuShow="handleRightMenuShow"
      ></RightMenu>
      <!-- 底部立即体验弹出 -->
      <ExperienceNow
        :isPopShow="isPopShow"
        @CloseExperienceNow="handleCloseExperienceNow"
      ></ExperienceNow>
    </div>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import Swiper, { Navigation } from "swiper";
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import CompanyInformation from "./include/CompanyInformation";
import ExperienceNow from "./include/ExperienceNow";
const function21 = require("../assets/img/homePage/function21.gif");
const function22 = require("../assets/img/homePage/function22.gif");
Swiper.use([Navigation]);
export default {
  name: "FusionIntegrationPhone",
  components: {
    PhoneFooter,
    PhoneHeader,
    CompanyInformation,
    RightMenu,
    ExperienceNow,
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
      videoPlayDialogVisible: false, // 顶部视频播放弹窗
      modelActive: "formular", // tab页默认显示
      mainActive: "first", // tab页默认显示
      funcSrc: "function21", // 动图播放完毕后显示gif
    };
  },
  watch: {
    mainActive(n) {
      if (n === "second") {
        this.funcSrc = function21;
        setTimeout(() => {
          this.funcSrc = function22;
        }, 3000);
      }
    },
  },
  methods: {
    // 了解更多
    handleRouter() {
      this.$router.push("/CasePhonePage");
    },
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* 头部 */
.banner-box {width: 100%;height: 391px;background: url("../assets/img/fusionIntegrationPhone/banner-bg.png") no-repeat;background-size: 100%;margin-top: 52px;}
.banner-con {width: 100%;margin: 0 auto;padding-top: 20px;}
.banner-title {font-size: 23px;font-weight: bold;line-height: 50px;text-align: center;display: flex;justify-content: center;}
.banner-desc {display: flex;align-items: center;position: relative;font-size: 16px;font-weight: 400;justify-content: center;}
.app-button-div{width: 100%;text-align: center;margin-top: 190px}
.app-button-img{width: 120px;}

.div-title {font-size: 22px;font-weight: bold;line-height: 50px;text-align: center;display: flex;justify-content: center;color: #2e2e2e;margin-top: 50px}
.div-desc {display: flex;align-items: center;position: relative;font-size: 14px;font-weight: 400;justify-content: center;color: #8E8E8E;margin-bottom: 30px}

.base-content-div{width: 92%;margin: 15px auto;box-shadow: 0px 0px 10px 1px rgba(0,46,154,0.15);border-radius: 5px 5px 5px 5px;display: flex}
.base-content-title{font-weight: bold;font-size: 16px;color: #014BE6;line-height: 31px; margin: 10px 0px 5px 15px;}
.base-content-desc{font-size: 13px;color: #2E2E2E;line-height: 22px;width: 210px; margin: 0px 0px 10px 15px;}
.base-content-div img{width: 130px;margin-top: 27px}

/* 企业数字化转型的底座 */
.digitalize {width: 100%;background: url("../assets/img/lowCodePhone/big-img-bg.png") no-repeat;background-size: 100% 100%;padding-top: 1px;}
.digitalize > img {width: 100%;margin-top: 20px;}
.digitalize-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding-top: 50px;padding-bottom: 25px;}
.digitalize-bg {text-align: center;padding: 0 18px;}
.digitalize-bg > img {width: 100%;margin-bottom: 40px;}

/* 主要功能 */
.main-method {overflow: hidden;}
.main-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding: 44px 0 24px 0;}
.main-tabs-tabItem {display: flex;margin: 20px 0 32px 0;justify-content: center;}
.main-tabs-tabItem > img {height: 200px;}
.main-tabs-tabItem-box {display: flex;justify-content: center;height: 100%;min-height: 100px;}
.main-tabs-tabItem-box > div {width: 90%;}
.main-tabs-tabItem-context-item {display: flex;margin-bottom: 30px;}
.main-tabs-tabItem-context-item > img {height: 20px;padding-right: 10px;}
.main-tabs-tabItem-context-item > div {font-size: 15px;line-height: 30px;}
van-tabs__wrap,
.van-tabs__wrap scroll-view,
.van-tabs__nav,
.van-tab {
  height: 130px!important;
  background-color: white;
}

/* 各类业务无缝集成 */
.core-value {background: #FFFFFF;}
.core-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding: 40px 0 30px 0;}
.core-layout {display: flex;padding-bottom: 30px;}
.core-content {width: 90%;margin: auto;color: #FFFFFF;}
.value-title {font-size: 16px;font-weight: bold;}
.value-desc {font-size: 13px;margin-top: 15px;line-height: 23px;color: #EEEEEE;text-align: justify}
.core-item {background: #3273F3;height: 170px;background-size: 100% 80px;margin-bottom: 20px;display: flex;padding: 20px 20px;border-radius: 3px;}
.core-item img{width: 110px;position: relative;left: 210px;top: -100px;}

/* 案例 */
.case {background: url("../assets/img/phoneHomePage/case-bg.png");height: 828px;}
.case-title {font-size: 25px;font-weight: bold;line-height: 56px;text-align: center;padding: 30px 0;color: white;}
.case-box {display: flex;justify-content: center;}
.case-swipe {height: 350px;}
.case-swipe >>> .van-swipe__indicators .van-swipe__indicator {background: #333333;}
.case-swipe >>> .van-swipe__indicator--active {background-color: #1989fa !important;}
.case-item {height: 100%;width: 90%;padding: 20px 20px 0 20px;background-image: linear-gradient(to bottom, #fff, #e9f0ff);border-radius: 5px;}
.van-swipe-item {display: flex;justify-content: center;}
.case-item > img {height: 55px;}
.case-item > .title {margin: 10px 0;font-size: 18px;font-weight: 600;}
.case-item > .text {font-size: 15px;font-weight: 400;line-height: 25px;}
.case-application-box {display: flex;justify-content: center;}
.case-application {width: 90%;height: 200px;padding: 20px;background: #203558;margin-top: 40px;}
.case-application .title {color: #fff;font-size: 18px;font-weight: bold;}
.case-application-items {display: flex;justify-content: space-between;}
.case-application-item > div {font-size: 15px;color: #fff;margin-bottom: 15px;}
.case > .btn {display: flex;justify-content: center;margin-top: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/FusionIntegrationPhone.vue